import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages.component';
import { TransactionsComponent } from '@pages/transactions/transactions.component';
import { IndividualTransactionComponent } from '@pages/transactions/individual-transaction/individual-transaction.component';
import { ClientStudyComponent } from '@pages/client-study/client-study.component';
import { OperationsComponent } from '@pages/operations/operations.component';
import { ClaimsComponent } from '@pages/claims/claims.component';
import { AgreementsComponent } from '@pages/agreements/agreements.component';
import { ReportsComponent } from '@pages/reports/reports.component';
import { AdministrationComponent } from '@pages/administration/administration.component';
import { TabsComponent } from '@pages/transactions/tabs/tabs.component';
import { MyPaymentsComponent } from '@pages/administration/my-payments/my-payments.component';
import { UsersComponent } from '@pages/administration/users/users.component';
import { DocumentsComponent } from '@pages/administration/documents/documents.component';
import { RespaldoComponent } from '@pages/administration/respaldo/respaldo.component';
import { FilingTableComponent } from '@pages/administration/filing-table/filing-table.component';
import { ProfileComponent } from '@pages/administration/profile/profile.component';
import { OperationsTabsComponent } from '@pages/operations/operations-tabs/operations-tabs.component';
import { AuthGuard } from '@guards/auth.guard';
import { RolGuard } from '@app/guards/rol.guard';
import { TabprincipalComponent } from './administration/tab-principal-document/tab-principal.component';
import { CheckStatusComponent } from './administration/check-status/check-status.component';
import { CashNowFactoringComponent } from '@pages/cash-now-factoring/cash-now-factoring.component';
import { CanDeactivateGuard } from '../guards/can-deactivate.guard';
import { CashNowGuard } from '@app/guards/cash-now.guard';
import { MyClientsComponent } from '@pages/my-clients/my-clients.component';
import { MyClientsTabsComponent } from '@pages/my-clients/my-clients-tabs/my-clients-tabs.component';
import { QrPaymentComponent } from './qr-payment/qr-payment.component';

const routes: Routes = [
  {
    path: 'pages',
    component: PagesComponent,
    canActivate: [AuthGuard, RolGuard],
    children: [
      {
        path: 'transacciones',
        component: TransactionsComponent,
        children: [
          { path: '', component: TabsComponent, canActivate: [AuthGuard] },
          {
            path:
              'transaccion-individual/:documentType/:documentNumber/:queryCode',
            component: IndividualTransactionComponent,
            canActivate: [AuthGuard],
          },
          {
            path:
              'transaccion-individual/:documentType/:documentNumber/:queryCode/:reservationCode',
            component: IndividualTransactionComponent,
            canActivate: [AuthGuard],
          },
          // {
          //   path: 'test', component: TabCheckComponent
          // }
        ],
      },
      {
        path: 'estudio-de-cliente',
        component: ClientStudyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'mis-clientes',
        component: MyClientsComponent,
        children: [
          {
            path: '',
            component: MyClientsTabsComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'operaciones',
        component: OperationsComponent,
        children: [
          {
            path: '',
            component: OperationsTabsComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'reclamaciones',
        component: ClaimsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'reintegros',
        component: ClaimsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'acuerdos-de-pago',
        component: AgreementsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'reportes',
        component: ReportsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'pago-por-qr',
        component: QrPaymentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'administracion',
        component: AdministrationComponent,
        children: [
          {
            path: 'mis-pagos',
            component: MyPaymentsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'usuarios',
            component: UsersComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'principal',
            component: TabprincipalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'documentos',
            component: DocumentsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'radicacion',
            component: FilingTableComponent,
          },
          {
            path: 'respaldos',
            component: RespaldoComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'consultar-estado',
            component: CheckStatusComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'perfil',
            component: ProfileComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'caja-ya',
        component: CashNowFactoringComponent,
        canActivate: [AuthGuard, CashNowGuard],
        canDeactivate: [CanDeactivateGuard]
      },
      { path: '**', pathMatch: 'full', redirectTo: '/not-found' },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
